var scrollTarget = document.getElementById("scrollToSection");

if (scrollTarget) {
    var navHeight = document.querySelector("nav.utility").getBoundingClientRect().height;
    var scrollTop = window.scrollY + parseInt(scrollTarget.getBoundingClientRect().top) - navHeight;
    if (scrollTop > 0) {
        window.scroll({
            top: scrollTop,
            behavior: "smooth"
        });
    }
}



// WEBPACK FOOTER //
// ../components/simple-scroll/simple-scroll.js